<template>
  <FormattedMessage :definition="translations.bodyRedirection">
    <template #provider>
      <strong class="body-2-bold">
        {{ group.config.providerName }}
      </strong>
    </template>
  </FormattedMessage>
</template>

<script setup lang="ts">
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'

import type { PaymentGroupData } from '../../../../methods/config/methods.type'

import translations from './DefaultRedirectionText.translations'

defineProps<{
  group: PaymentGroupData
}>()
</script>
